import { APP_NAME, APP_SUBTITLE } from '../data/knowledgeBase';

export const Header = () => {
  return (
    <header className="hero">
      <div className="hero__topline">
        <span className="hero__badge">Planejador de Reuniões de Alta Performance</span>
        <span className="hero__tag">DEPIN e DEAGI</span>
      </div>
      <h1>{APP_NAME}</h1>
      <p className="hero__subtitle">{APP_SUBTITLE}</p>
      <p className="hero__description">
        Prepare reuniões com foco em gerar resultado e prosperidade ao cooperado, conduzindo a conversa para valor, produtividade e rentabilidade, e não apenas para preço. É hora de cruzar a "linha amarela" e dar show!
      </p>
      <div className="hero__highlights">
        <span>OPC | Direção estratégica</span>
        <span>SPIN | Diagnóstico consultivo</span>
        <span>EPA | Provocação de valor</span>
        <span>Senoide | Narrativa de decisão</span>
      </div>
    </header>
  );
};
